import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { RefreshCw } from 'lucide-react';

/**
 * UpdatePrompt - Zorunlu güncelleme bildirimi
 * Dismiss edilemez, 5 saniye sonra otomatik güncellenir
 */
export default function UpdatePrompt({ onUpdate }) {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown <= 0) {
      onUpdate();
      return;
    }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, onUpdate]);

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl border border-cyan-200 p-6 max-w-sm w-full text-center">
        <div className="w-14 h-14 rounded-full bg-cyan-100 flex items-center justify-center mx-auto mb-4">
          <RefreshCw className="w-7 h-7 text-cyan-600 animate-spin" />
        </div>
        
        <h3 className="font-bold text-gray-900 text-lg mb-2">
          Yeni Güncelleme Mevcut
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          OnxFlow güncellendi. En iyi deneyim için uygulama yeniden yüklenecek.
        </p>
        
        <Button
          onClick={onUpdate}
          className="w-full bg-gradient-to-r from-cyan-600 to-blue-600"
          data-testid="force-update-button"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Şimdi Güncelle ({countdown}s)
        </Button>
      </div>
    </div>
  );
}
